module.exports = __webpack_public_path__ + "img/page.49025b6b.png";